import React, {useEffect} from 'react';
import {StateDictionary} from '../Models/AbroadPackageModels';
import {isMobile} from 'react-device-detect';
import '../Sass/AbroadStateInclude.scss';
import Config from '../../../../../Config';

interface AbroadStateIncludeProps {
  importantInfo: string[];
  policiesEpi: string;
  showBusinessTerms: any;
  openAgreementPDF: any;
}



const ImportantPart = ({importantInfo, policiesEpi, showBusinessTerms, openAgreementPDF}: AbroadStateIncludeProps) => {
  const ImportantPartRendering = () => {
    return importantInfo.map((value, index) => {
      return (
        <div
          className='abroadStateInclude__content__row important-part'
          key={index}
          dangerouslySetInnerHTML={{__html: value}}
        />
      );
    });
  };
  return (
    <div className={isMobile ? 'abroadStateInclude isMobile' : 'abroadStateInclude'}>
      <div className='abroadStateInclude__title'>חשוב שתדע</div>
      <div className='abroadStateInclude__content'>{ImportantPartRendering()}</div>
      <a href='javascript:void(0);' style={{color: 'var(--theme-primary, #810EA9)'}} onClick={() => (policiesEpi ? openAgreementPDF() : showBusinessTerms())}>
        לתנאי חבילה המלאים
      </a>
    </div>
  );
};

export default ImportantPart;
